import { Autocomplete, FormControl, TextField } from '@chronosphereio/chrono-ui';
import { useDashboardTemplateVariableValues } from '../../context';

interface VariableAutocompleteProps {
  value?: string;
  onChange: (value: string) => void;
}

export function VariableAutocomplete({ value, onChange }: VariableAutocompleteProps) {
  const dashboardVariables = useDashboardTemplateVariableValues();

  return (
    <FormControl fullWidth margin="normal">
      <Autocomplete
        options={Object.keys(dashboardVariables)}
        value={value}
        onChange={(_, newValue) => onChange(newValue ?? '')}
        renderInput={(params) => <TextField {...params} label="Variable name" />}
      />
    </FormControl>
  );
}
